import { useWindowDimensions } from './useWindowDimensions'

export const useMobileCheck = (): boolean => {
  const { windowWidth } = useWindowDimensions()
  return windowWidth < 640
}
